<template>
  <div class="input-group">
    <div class="input-group-prepend">
      <span class="input-group-text" id="basic-addon1"
        ><i class="fas fa-search"></i
      ></span>
    </div>
    <input
      type="text"
      class="form-control"
      :placeholder="placeholderText"
      v-model.lazy="currentSearchText"
      @keyup.enter="enterSearch"
    />
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {}
  },
  data() {
    return {
      placeholderText: this.placeholder || this.$t("label.search"),
      currentSearchText: ""
    };
  },
  watch: {
    placeholder(value) {
      this.placeholderText = value;
    }
  },
  mounted() {
    this.placeholderText = this.placeholder || this.$t("label.search");
  },
  methods: {
    enterSearch() {
      this.$emit("search", this.currentSearchText);
    }
  }
};
</script>

<style lang="scss" scoped>
.input-group {
  &-text {
    background: $white;
    border-right: none;
    border-radius: 25px 0 0 25px;
    line-height: 40px;
  }
  .form-control {
    font-size: 14px;
    font-weight: 500;
    color: #616161;
    line-height: 1.87;
    border: 1px solid #ced4da;
    border-left: none;
    border-radius: 0 25px 25px 0;
    padding: 0px;
    height: 34px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/helper/SearchInput.vue